import { ColDef, SideBarDef } from '@medpacesoftwaredevelopment/designsystem/lib/components/ag-grid';

export class AgGridDefaults {
    public static readonly defaultColDef: ColDef = {
        flex: 1,
        minWidth: 140,
        filter: 'agMultiColumnFilter',
        floatingFilter: true,
    };

    public static readonly defaultSidebar: SideBarDef = {
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                },
            },
        ],
    };
}
